export function createDisconnectHandler(
  write: (text: string) => void,
  onDisconnect: () => void,
) {
  let disconnected = false;
  return () => {
    if (disconnected) return;
    disconnected = true;
    write("\r\n[disconnect]\r\n");
    onDisconnect();
  };
}
